import { useSocketIO } from "@features/builder/hooks/socketIOHooks"
import { useEffect, useState } from "react"

export const useIsSocketConnected = () => {
  const socket = useSocketIO()
  const [isSocketConnected, setIsSocketConnected] = useState(socket.connected)
  const [hadConnectionProblems, setHadConnectionProblems] = useState(false)

  type SocketListener = NonNullable<Parameters<typeof socket.off>[1]>
  type DisconnectReason = Parameters<SocketListener>[0]
  type SocketError = { status?: number; data?: { status?: number } }

  const handleSocketConnect = () => setIsSocketConnected(true)
  const handleSocketDisconnect = (reason?: DisconnectReason) => {
    setIsSocketConnected(false)

    if (reason === "io client disconnect") return

    setHadConnectionProblems(true)
  }

  const handleSocketError = (err: SocketError) => {
    const status = err.status ?? err.data?.status
    if (status !== 402) return

    setIsSocketConnected(false)
    setHadConnectionProblems(true)
  }

  useEffect(() => {
    socket.on("connect", handleSocketConnect)
    socket.on("disconnect", handleSocketDisconnect)
    socket.on("error", handleSocketError)

    return () => {
      socket.off("connect", handleSocketConnect)
      socket.off("disconnect", handleSocketDisconnect)
      socket.off("error", handleSocketError)
    }
  })

  return { isSocketConnected, hadConnectionProblems }
}
